// @ts-nocheck
import { createContext, useContext } from 'react';

import type { CampaignProgressAndGoals, PaginatedStatsResult } from 'sonata-static-storage/lib/common/common.types';
import type { SummaryItem } from '@/ts-types/reporting.types';

export const SUMMARY_ITEM_KEYS = [
  // todo DO NOT ORDER THESE KEYS
  'impressions',
  'viewability',
  'lumenAttention',
  'engagements',
  'clicks',
  'video',
  'audio',
  'doohPatrimony',
  'attribution',
  'driveToStoreAttribution',
  'appsInstall',
  'digitalConversions',
  'pageViewed',
  'spend'
] as const;
export type SummaryItemKey = (typeof SUMMARY_ITEM_KEYS)[number];

export type ProviderState = {
  currency: string;
  summaryAnalyticalCampaignViewByDayStats: Record<string, PaginatedStatsResult['results']>;
  summaryAnalyticalViewStats: {
    lastDays: PaginatedStatsResult['results'];
    lastHours: PaginatedStatsResult['results'];
  };
  summaryDOOHStats: {
    screenAvgImpacts: number;
    screenAvgImpactsByCampaign?: Record<string, number>;
    screensNumber: number;
    screensNumberByCampaign?: Record<string, number>;
  };
  summaryDetailStats: CampaignProgressAndGoals[];
  summaryItemsKeys: SummaryItemKey[];
  summaryStats: PaginatedStatsResult['metadata']['totalResults'];
  summaryStatsByCampaign: Record<string, PaginatedStatsResult['metadata']['totalResults']>;
};

export interface ContextProps {
  getSummaryAnalyticalCampaignByDayStats: () => ProviderState['summaryAnalyticalCampaignViewByDayStats'];
  getSummaryAnalyticalStats: () => ProviderState['summaryAnalyticalViewStats'];
  getSummaryDOOHStats: () => ProviderState['summaryDOOHStats'];
  getSummaryDetailStats: () => ProviderState['summaryDetailStats'];
  getSummaryItem: (
    itemKey: SummaryItemKey,
    campaigns: Record<string, any>[],
    stats: Record<string, any>
  ) => SummaryItem;
  getSummaryItems: (
    itemKeys: SummaryItemKey[],
    campaigns: Record<string, any>[],
    stats: Record<string, any>
  ) => SummaryItem[];
  getSummaryStats: () => ProviderState['summaryStats'];
  getSummaryStatsByCampaign: () => ProviderState['summaryStatsByCampaign'];
  summaryAnalyticalCampaignByDayStatsError: boolean;
  summaryAnalyticalCampaignByDayStatsReady: boolean;
  summaryAnalyticalStatsError: boolean;
  summaryAnalyticalStatsReady: boolean;
  summaryDetailStatsError: boolean;
  summaryDetailStatsReFetch: () => void;
  summaryDetailStatsReady: boolean;
  summaryItemsKeys: SummaryItemKey[];
  summaryStatsError: boolean;
  summaryStatsReady: boolean;
}

const SummaryContext = createContext<ContextProps>({} as ContextProps);

SummaryContext.displayName = 'ReportingSummaryContext';
export default SummaryContext;

export const useSummaryContext = (): ContextProps => {
  const context = useContext(SummaryContext);
  if (!context) {
    throw new Error('useSummaryContext must be used within a SummaryProvider');
  }
  return context;
};
